<ul id="work-packages-timeline-mode-selection"
  class="toolbar-button-group work-packages-timeline-toggle-button">

  @if (isActive) {
    <li>
      <button id="work-packages-timeline-zoom-auto-button"
        class="button timeline-toolbar--button toolbar-icon"
        [ngClass]="getAutoZoomToggleClass()"
        [attr.title]="text.zoomAuto"
        (click)="enableAutoZoom()">
        <op-icon icon-classes="icon-zoom-auto button--icon" />
      </button>
    </li>
  }

  @if (isActive) {
    <li>
      <button id="work-packages-timeline-zoom-out-button"
        class="button timeline-toolbar--button toolbar-icon"
        [attr.title]="text.zoomOut"
        [disabled]="isMaxLevel"
        (click)="updateZoomWithDelta(1)">
        <op-icon icon-classes="icon-zoom-out button--icon" />
      </button>
    </li>
  }

  @if (isActive) {
    <li>
      <button id="work-packages-timeline-zoom-in-button"
        class="button timeline-toolbar--button toolbar-icon"
        [attr.title]="text.zoomIn"
        [disabled]="isMinLevel"
        (click)="updateZoomWithDelta(-1)">
        <op-icon icon-classes="icon-zoom-in button--icon" />
      </button>
    </li>
  }
</ul>
